var modules_b21bc4dc = {"socialsIcons":"_syhma9"};
import "../../../assets/BZ6DRme9.css";

export { modules_b21bc4dc as default };
//# sourceMappingURL=Socials.module.less.js.map
